import moment from 'moment';
import DatePickerComponent from '../../components/date-picker/date-picker.component';
import SelectCommonSearchInputComponent from '../../components/posm/common-search/common-search-input.component';
import { COMMON_SEARCH_DATA_TYPES, formats } from '../../config/constants';
import ViewBase from '../view-base.view';
import SelectUserComponent from '../../components/user/select-user.component';

export default function SEAOPOSMGoodsMovementFooter() {
  ViewBase.call(this);

  let selectedVendorItems = [];
  let selectedRequestor = [];
  return {
    view: ({ attrs: { filterObj: inputDataModel, setFilterObj, onSearchForGoodMovementList, setCurrentFilter, handleClear } }) => {
      return [
        m('.row.g-2',
          m('.col-md-4.col-lg-4.position-relative',
            m('label.form-label', this.getText('LT00000132', 'Date')),
            m('.input-group',
              m(DatePickerComponent, {
                class: 'form-control',
                isRange: true,
                readonly: true,
                grid: 1,
                calendars: 1,
                date: formats.dateFormat,
                dateStart: inputDataModel.DateFrom && moment(inputDataModel.DateFrom).format(formats.dateFormat),
                dateEnd: inputDataModel.DateTo && moment(inputDataModel.DateTo).format(formats.dateFormat),
                required: true,
                onselect: (e) => {
                  setFilterObj({
                    DateFrom: moment(e.detail.start).format(formats.apiDateFormat),
                    DateTo: moment(e.detail.end).format(formats.apiDateFormat)
                  })
                }
              })
            )
          ),
          m('.col-md-4.col-lg-4.position-relative',
            m('label.form-label', this.getText('LT00001088', 'Vendor')),
            m('.input-group',
              m(SelectCommonSearchInputComponent, {
                multiple: true,
                dataType: COMMON_SEARCH_DATA_TYPES.VENDOR,
                setFilterObj,
                selectedItems: selectedVendorItems,
                onSelect:
                  (model) => {
                    selectedVendorItems = model;
                    setFilterObj({ VendorID: model.map(({ code }) => code).join('^') })
                    // inputDataModel[params] = payload.code
                  }
              }))
          ),
          m('.col-md-4.col-lg-4.position-relative',
            m('label.form-label', this.getText('LT00001241', 'Requester')),
            m('.input-group', m(SelectUserComponent, {
              default: {
                userStatusCode: '0001'
              },
              multiple: true,
              onSelect: (selectedUserList) => {
                selectedRequestor = selectedUserList
                setFilterObj({ MovementBy: selectedRequestor.map(({ userID }) => userID).join('^') })
              },
              selectedUserList: selectedRequestor,
            }))
          ),
          m('.col-12.d-flex.justify-content-end.gap-2',
            m(
              'button.btn.btn-primary',
              {
                onclick: () => {
                  setCurrentFilter();
                  onSearchForGoodMovementList(true);
                },
              },
              this.getText('LT00000001', 'Search')
            ),
            m(
              'button.btn.btn-white',
              {
                onclick: () => {
                  selectedVendorItems = [];
                  selectedRequestor = [];
                  handleClear();
                },
              },
              this.getText('LT00000031', 'Clear')
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
